import React, { forwardRef } from 'react';

const formatRating = (rating) => {
  if (rating == null) return '--';
  return Math.round(rating).toString();
};

const BoxpressdTopRatedCard = forwardRef(
  (
    {
      title = 'COMMUNITY PICK',
      subtitle = 'Top Rated This Week',
      cigarBrand = 'Don Kiki',
      cigarName = 'Gold Label Robusto',
      country = 'NICARAGUA',
      rating = 91,
      cigarImage,
      imageOffsetX = 0,
      imageOffsetY = 0,
      accentColor = '#d3a966',
      backgroundColor = '#f7f5f0',
      textColor = '#1f1b17',
      footerText = 'Based on user ratings.',
      strengthContent = null, // optional JSX to place where the removed text block used to be
    },
    ref
  ) => {
    return (
      <div
        ref={ref}
        style={{
          width: 1080,
          height: 1080,
          position: 'relative',
          overflow: 'hidden',
          background: backgroundColor,
          fontFamily: '"Georgia", "Times New Roman", serif',
          color: textColor,
          boxSizing: 'border-box',
        }}
      >
        {/* subtle paper texture replacement */}
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background:
              'radial-gradient(circle at 20% 20%, rgba(255,255,255,0.6), transparent 30%), radial-gradient(circle at 80% 30%, rgba(255,255,255,0.35), transparent 35%), radial-gradient(circle at 50% 80%, rgba(255,255,255,0.25), transparent 30%)',
            opacity: 0.7,
            pointerEvents: 'none',
          }}
        />

        {/* border */}
        <div
          style={{
            position: 'absolute',
            top: 70,
            left: 65,
            right: 65,
            bottom: 130,
            border: `3px solid ${accentColor}`,
            boxSizing: 'border-box',
          }}
        />

        {/* top heading */}
        <div
          style={{
            position: 'absolute',
            top: 38,
            left: '50%',
            transform: 'translateX(-50%)',
            background: backgroundColor,
            padding: '0 28px',
            fontSize: 36,
            letterSpacing: 2,
            color: accentColor,
            fontWeight: 500,
            textTransform: 'uppercase',
          }}
        >
          {title}
        </div>

        {/* script subtitle */}
        <div
          style={{
            position: 'absolute',
            top: 150,
            left: 96,
            fontSize: 90,
            lineHeight: 1,
            color: accentColor,
            fontFamily: '"Great Vibes", cursive',
            fontWeight: 500,
          }}
        >
          {subtitle}
        </div>

        {/* cigar info */}
        <div
          style={{
            position: 'absolute',
            top: 305,
            left: 100,
            width: 680,
          }}
        >
          <div
            style={{
              fontSize: 46,
              lineHeight: 1.06,
              fontWeight: 500,
              letterSpacing: -1,
            }}
          >
            {cigarBrand}
          </div>
          <div
            style={{
              fontSize: 74,
              lineHeight: 1.06,
              fontWeight: 500,
              letterSpacing: -1,
            }}
          >
            {cigarName}
          </div>

          <div
            style={{
              marginTop: 36,
              fontSize: 28,
              letterSpacing: 1,
              textTransform: 'uppercase',
              fontFamily: 'Arial, Helvetica, sans-serif',
            }}
          >
            {country}
          </div>
        </div>

        {/* optional strength area */}
        <div
          style={{
            position: 'absolute',
            left: 100,
            top: 775,
            width: 310,
            minHeight: 150,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
          }}
        >
          {strengthContent}
        </div>

        {/* rating box */}
        <div
          style={{
            position: 'absolute',
            left: 570,
            top: 645,
            width: 210,
            height: 250,
            background: '#fbfaf7',
            border: `2px solid rgba(31,27,23,0.35)`,
            boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            padding: '14px 18px',
            boxSizing: 'border-box',
          }}
        >
          <div
            style={{
              textAlign: 'center',
              fontFamily: 'Arial, Helvetica, sans-serif',
              fontSize: 24,
              color: '#6d6258',
              textTransform: 'uppercase',
            }}
          >
            <div
              style={{
                borderBottom: `2px solid ${accentColor}`,
                paddingBottom: 8,
              }}
            >
              Rated
            </div>
          </div>

          <div
            style={{
              textAlign: 'center',
              fontSize: 110,
              lineHeight: 1,
              fontWeight: 700,
              fontFamily: 'Arial, Helvetica, sans-serif',
            }}
          >
            {formatRating(rating)}
          </div>

          <div
            style={{
              textAlign: 'center',
              fontFamily: 'Arial, Helvetica, sans-serif',
              fontSize: 24,
              letterSpacing: 1,
              borderTop: `2px solid ${accentColor}`,
              paddingTop: 10,
              textTransform: 'uppercase',
            }}
          >
            BOXPRESSD
          </div>
        </div>

        {/* cigar image on right */}
        {cigarImage ? (
          <div
            style={{
              position: 'absolute',
              right: 56 + imageOffsetX,
              bottom: 70 + imageOffsetY,
              width: 260,
              height: 900,
              display: 'flex',
              alignItems: 'flex-end',
              justifyContent: 'center',
              overflow: 'visible',
            }}
          >
            <img
              src={cigarImage}
              alt={cigarName}
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                width: 'auto',
                height: 'auto',
                minHeight: 900,
                display: 'block',
                filter: 'drop-shadow(0 18px 22px rgba(0,0,0,0.18))',
              }}
            />
          </div>
        ) : (
          <div
            style={{
              position: 'absolute',
              right: 135,
              bottom: 100,
              width: 150,
              height: 560,
              borderRadius: 75,
              background:
                'linear-gradient(180deg, #6e432c 0%, #5b3623 35%, #4a2d1f 100%)',
              boxShadow: '0 18px 22px rgba(0,0,0,0.18)',
            }}
          />
        )}

        {/* footer */}
        <div
          style={{
            position: 'absolute',
            display: 'flex',
            left: 50,
            bottom: 38,
            fontSize: 28,
            color: '#5f554d',
            alignItems: 'center',
          }}
        >
          <img
            src="http://localhost:3000/static/media/logo-v2.7fdf5dae374bee09768d.png"
            alt="Boxpressd"
            style={{ marginRight: 196, width: 280 }}
          />
          {footerText}
        </div>
      </div>
    );
  }
);

export default BoxpressdTopRatedCard;
